import {
    CoverageBox,
    CoverageButton,
    CoverageList,
    CoverageListItem,
    pickValuesStartWith,
    replaceStr
} from 'flos-react-cvi';
import React from 'react';

/**
 *
 * @param {ICoverage} props
 */
export const CoverageOption = ({
    nameId,
    resources,
    chosen,
    required,
    installmentPrice,
    isPrimary,
    onToggle,
    isLoading,
    disabled
}) => {
    const covers = React.useMemo(() => pickValuesStartWith(resources, `coverage\\.${nameId}\\.cover\\.`), [
        resources,
        nameId
    ]);
    const hasCovers = covers.length > 0;
    const nonCovers = React.useMemo(() => pickValuesStartWith(resources, `coverage\\.${nameId}\\.notCover\\.`), [
        resources,
        nameId
    ]);
    const hasNonCovers = nonCovers.length > 0;

    if (nameId === 'farlig-sport' || nameId === 'kortslutning-mm.') {
        return null;
    }

    const title = resources[`coverage.${nameId}.title`];
    const subtitle = resources[`coverage.${nameId}.subtitle`];
    const description = resources[`coverage.${nameId}.description`];

    return (
        <CoverageBox
            title={title}
            subtitle={subtitle}
            icon={chosen ? 'included' : 'upgrade'}
            toggleBtnContent={resources.coverageOptionToggleDetailsText}
            content={
                (hasCovers || hasNonCovers || description) && (
                    <>
                        {description && <p>{description}</p>}
                        {hasCovers && (
                            <>
                                <strong className="title">{resources[`coverage.${nameId}.coverTitle`]}</strong>
                                <CoverageList>
                                    {covers.map(({ key, value }) => (
                                        <CoverageListItem icon="included" key={key}>
                                            {value}
                                        </CoverageListItem>
                                    ))}
                                </CoverageList>
                            </>
                        )}
                        {hasNonCovers && (
                            <>
                                <strong className="title">{resources[`coverage.${nameId}.notCoverTitle`]}</strong>
                                <CoverageList>
                                    {nonCovers.map(({ key, value }) => (
                                        <CoverageListItem icon="excluded" key={key}>
                                            {value}
                                        </CoverageListItem>
                                    ))}
                                </CoverageList>
                            </>
                        )}
                    </>
                )
            }
            actions={
                required && isPrimary ? (
                    <CoverageButton variant="white" disabled>
                        {resources.coverageOptionStatusRequired}
                    </CoverageButton>
                ) : chosen ? (
                    <CoverageButton
                        onClick={onToggle}
                        loadingText={resources.coverageOptionStatusRemoving}
                        isLoading={isLoading}
                        disabled={disabled}
                        variant="primary-outline"
                        data-testid={`toggle-btn-${nameId}`}
                    >
                        {resources.coverageOptionStatusRemove}
                    </CoverageButton>
                ) : (
                    <CoverageButton
                        onClick={onToggle}
                        isLoading={isLoading}
                        disabled={disabled}
                        loadingText={resources.coverageOptionStatusAdding}
                        data-testid={`toggle-btn-${nameId}`}
                    >
                        {resources.coverageOptionStatusAdd}
                    </CoverageButton>
                )
            }
            actionSubtext={
                (required && isPrimary) || chosen
                    ? null
                    : replaceStr(resources.coverageOptionPrice, {
                          '{price}': installmentPrice
                      })
            }
        />
    );
};
